module.exports = __webpack_public_path__ + "img/staff.275492c3.svg";